

exports.__esModule = true;
exports.$AddCardPageRoute = undefined;

require('xo-wallet-components/src/add-card/route');

require('./directive');

var _squid = require('squid');

var $AddCardPageRoute = exports.$AddCardPageRoute = _squid.$ComponentRoute.extend('$AddCardPageRoute', {

    path: 'pageAddCard',
    directive: 'xo-page-add-card-page',
    titleContent: 'asideHeader.addCard',
    query: ['cause', 'message'],
    trackingData: {
        templateName: 'addCard.dust',
        pageGoal: 'Add Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-cc',
                'pagename2': '%::fullpage-add-cc:member:hermes:',
                'version': 'member:%:'
            }
            // More page qualifiers come here...
        }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            pagetitle: 'pagetitle',
            'parent-callbacks': 'callbacks',
            logout: 'logout',
            'show-cancel': 'showCancel'
        }
    }]
});

angular.value("$AddCardPageRoute", $AddCardPageRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-card/route.js
// module id = ./pages/xo-add-card/route.js
// module chunks = 1